import * as THREE from 'three'
import { loadModel } from '@/utils/loader'
import { randIntSpread } from '@/utils/random'
import { applyMaterial } from '@/utils/material'

/* eslint-disable */
const defaultSettings = {
  length: 500,     // length of area (x)
  width: 500,      // width of area (z)
  height: 20,      // height of area (y)
  speed: 50        // speed per second
}
/* eslint-enable */

const up = new THREE.Vector3(0, 1, 0)

const createCurve = (length, width, height) => new THREE.CatmullRomCurve3([
  new THREE.Vector3(-length / 2, randIntSpread(height / 2), randIntSpread(width / 2)),
  new THREE.Vector3(0, randIntSpread(height / 2), randIntSpread(width / 2)),
  new THREE.Vector3(length / 2, randIntSpread(height / 2), randIntSpread(width / 2))
])

export default class Seagull extends THREE.Object3D {
  name = 'Seagull'

  constructor (settings) {
    super()

    this.debug = process.env.NODE_ENV !== 'production'
    this.settings = Object.assign({}, defaultSettings, settings)

    loadModel('/models/objects/seagull.glb', gltf => {
      this.seagull = gltf.scene
      this.seagull.traverse(child => {
        if (child.isMesh) {
          applyMaterial(child)
        }
      })

      this.add(this.seagull)

      this.reset()
      this.debug && this.drawpath()
    })
  }

  reset () {
    const { length, width, height } = this.settings

    this.curve = createCurve(length, width, height)
    this.length = this.curve.getLength()
    this.step = 0

    this.rotateY(Math.PI * Math.random())
  }

  drawpath () {
    if (this.path) {
      const points = this.curve.getPoints(50)
      this.path.geometry.setFromPoints(points)
      return
    }

    const points = this.curve.getPoints(50)
    const geometry = new THREE.BufferGeometry().setFromPoints(points)
    const material = new THREE.LineBasicMaterial()
    this.path = new THREE.Line(geometry, material)
    this.add(this.path)
  }

  update (delta) {
    if (!this.seagull) return

    this.step += delta * this.settings.speed

    if (this.step > this.length) {
      this.reset()
      this.debug && this.drawpath()
    }

    const position = this.curve.getPointAt(this.step / this.length)
    const tangent = this.curve.getTangentAt(this.step / this.length).normalize()
    const angle = Math.atan2(tangent.x, tangent.z) - Math.PI / 2

    this.seagull.position.copy(position)
    this.seagull.quaternion.setFromAxisAngle(up, angle)
  }
}
